import PropTypes from "prop-types";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
import {
  backgroundDark,
  backgroundLight,
  borderColorDark,
  borderColorLight,
  defaultTheme,
  statusDark,
  statusLight,
  textDark,
  textLight,
  ThemeModeEnum,
} from "_constants";
import React, { useMemo } from "react";
import { getAntTheme } from "_helpers";
import { useMainStore } from "_hooks";

const AppThemeProvider = (props) => {
  const { children } = props;

  const {
    main: { themeMode },
  } = useMainStore();

  const theme = useMemo(() => {
    let currentTheme = { ...defaultTheme.theme };
    if (themeMode === ThemeModeEnum.LIGHT) {
      currentTheme.palette.text = textLight;
      currentTheme.palette.background = backgroundLight;
      currentTheme.palette.borderColor = borderColorLight;
      currentTheme.palette.status = statusLight;
    } else {
      currentTheme.palette.text = textDark;
      currentTheme.palette.background = backgroundDark;
      currentTheme.palette.borderColor = borderColorDark;
      currentTheme.palette.status = statusDark;
    }
    return currentTheme;
  }, [themeMode]);

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider
        theme={{
          token: getAntTheme(theme),
          components: {
            Select: {
              optionSelectedBg: theme.palette.background.default,
              optionSelectedColor: theme.palette.text.secondary,
            },
            Input: {
              addonBg: theme.palette.background.authCard,
            },
            Layout: {
              siderBg: theme.sideBar.dark.sidebarBgColor,
              lightSiderBg: theme.sideBar.light.sidebarBgColor,
            },
            Menu: {
              darkItemBg: theme.sideBar.dark.sidebarBgColor,
              darkItemSelectedBg: theme.sideBar.dark.sidebarMenuSelectedBgColor,
              itemBg: theme.sideBar.light.sidebarBgColor,
              itemSelectedBg: theme.sideBar.light.sidebarMenuSelectedBgColor,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default React.memo(AppThemeProvider);

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
